import { useState, useEffect } from "react";
import Modal from "../../../../parts/modal-new";
import VideoUpload from "../components/VideoUpload";
import SvgIcon from "../../../../parts/SvgIcon";

const id = "modal-set-your-goals";
const form = "set-your-goals";

const GoalItem = ({ text }) => {
  return (
    <div className="flex items-center gap-4 pt-3">
      <SvgIcon src="/img/new-icons/check-circle.svg" classNames="w-4 h-4" />
      <p className="p5 pt-[0.15rem]">{text}</p>
    </div>
  );
};

const SetYourGoals = ({ workflow, explanationAdded }) => {
  const [addVideo, setAddVideo] = useState(false);
  useEffect(() => {
    if (explanationAdded) {
      setAddVideo(false);
    }
  }, [explanationAdded]);
  return (
    <form
      action={
        addVideo
          ? "/actions/getting-started/video"
          : "/actions/refresh?modal=&explanationAdded="
      }
      method={addVideo ? "POST" : "GET"}
      encType="multipart/form-data"
      data-noreset
      id={form}
    >
      {addVideo ? (
        <>
          <input type="hidden" name="option" value="goals" />
          <input type="hidden" name="workflow" value={workflow._id} />
        </>
      ) : (
        <>
          <input type="hidden" name="modal" value="" />
          <input type="hidden" name="explanationAdded" value="" />
        </>
      )}

      <Modal
        name={id}
        key={id}
        title="Set your goals"
        className="getting-started-video"
        toClear={["explanationAdded"]}
      >
        <div className="body">
          {addVideo ? (
            <VideoUpload
              form={form}
              video={workflow.options.goals?.video}
              explanationVideo
              goBack={() => setAddVideo(false)}
            />
          ) : (
            <div className="flex gap-6">
              <img
                src="/img/getting-started-goals.webp"
                className="max-w-72 rounded-[--border-radius-md]"
              />

              <div className="max-w-96">
                <p className="p5 mb-4">
                  Give users the ability to define and track goals, whether it's
                  steps, bodyweight, personal records, sleep or any custom goal,
                  helping them stay motivated as they monitor their progress.
                </p>

                <GoalItem text="Daily step count goals" />
                <GoalItem text="Daily sleep goals" />
                <GoalItem text="Bodyweight goals" />
                <GoalItem text="Personal record goal" />
                <GoalItem text="Custom goal" />
              </div>
            </div>
          )}
        </div>

        <footer className="foot">
          {!addVideo && !explanationAdded && (
            <button
              onClick={() => setAddVideo(true)}
              type="button"
              data-button-type="outline"
              className="mr-auto"
            >
              <span>Add Explanation Video</span>
            </button>
          )}
          <button data-button-type="primary" type="submit">
            {addVideo ? "Add Video" : "Save"}
          </button>
        </footer>
      </Modal>
    </form>
  );
};

export default SetYourGoals;
